import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { getLearningMode, LearningMode } from "../state";
import { getLearningModeFromParams } from "./withLearningModeQueryParams";

export default function useLearningMode(): LearningMode {
  const location = useLocation();
  const fromParams = getLearningModeFromParams(location.search);

  const fromState = useSelector(getLearningMode);

  return fromParams || fromState;
}
